"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Desio certificazione contatti
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CertificazioneCellulareDtoToJSON = exports.CertificazioneCellulareDtoFromJSONTyped = exports.CertificazioneCellulareDtoFromJSON = void 0;
const runtime_1 = require("../runtime");
function CertificazioneCellulareDtoFromJSON(json) {
    return CertificazioneCellulareDtoFromJSONTyped(json, false);
}
exports.CertificazioneCellulareDtoFromJSON = CertificazioneCellulareDtoFromJSON;
function CertificazioneCellulareDtoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !runtime_1.exists(json, 'id') ? undefined : json['id'],
        'idCertificazioneEmail': !runtime_1.exists(json, 'idCertificazioneEmail') ? undefined : json['idCertificazioneEmail'],
        'idStatoCertificazione': !runtime_1.exists(json, 'idStatoCertificazione') ? undefined : json['idStatoCertificazione'],
        'token': !runtime_1.exists(json, 'token') ? undefined : json['token'],
        'cellulareCertificazione': !runtime_1.exists(json, 'cellulareCertificazione') ? undefined : json['cellulareCertificazione'],
        'testoSms': !runtime_1.exists(json, 'testoSms') ? undefined : json['testoSms'],
        'ipAddressUtente': !runtime_1.exists(json, 'ipAddressUtente') ? undefined : json['ipAddressUtente'],
        'userAgentUtente': !runtime_1.exists(json, 'userAgentUtente') ? undefined : json['userAgentUtente'],
        'dataInserimento': !runtime_1.exists(json, 'dataInserimento') ? undefined : (new Date(json['dataInserimento'])),
        'dataUltimaModifica': !runtime_1.exists(json, 'dataUltimaModifica') ? undefined : (new Date(json['dataUltimaModifica'])),
        'dataInvioSms': !runtime_1.exists(json, 'dataInvioSms') ? undefined : (new Date(json['dataInvioSms'])),
        'dataScadenzaToken': !runtime_1.exists(json, 'dataScadenzaToken') ? undefined : (new Date(json['dataScadenzaToken'])),
        'dataCertificazione': !runtime_1.exists(json, 'dataCertificazione') ? undefined : (json['dataCertificazione'] === null ? null : new Date(json['dataCertificazione'])),
        'isInviata': !runtime_1.exists(json, 'isInviata') ? undefined : json['isInviata'],
        'erroreInvioCellulare': !runtime_1.exists(json, 'erroreInvioCellulare') ? undefined : json['erroreInvioCellulare'],
        'statoCertificazioneDesc': !runtime_1.exists(json, 'statoCertificazioneDesc') ? undefined : json['statoCertificazioneDesc'],
    };
}
exports.CertificazioneCellulareDtoFromJSONTyped = CertificazioneCellulareDtoFromJSONTyped;
function CertificazioneCellulareDtoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'idCertificazioneEmail': value.idCertificazioneEmail,
        'idStatoCertificazione': value.idStatoCertificazione,
        'token': value.token,
        'cellulareCertificazione': value.cellulareCertificazione,
        'testoSms': value.testoSms,
        'ipAddressUtente': value.ipAddressUtente,
        'userAgentUtente': value.userAgentUtente,
        'dataInserimento': value.dataInserimento === undefined ? undefined : (value.dataInserimento.toISOString()),
        'dataUltimaModifica': value.dataUltimaModifica === undefined ? undefined : (value.dataUltimaModifica.toISOString()),
        'dataInvioSms': value.dataInvioSms === undefined ? undefined : (value.dataInvioSms.toISOString()),
        'dataScadenzaToken': value.dataScadenzaToken === undefined ? undefined : (value.dataScadenzaToken.toISOString()),
        'dataCertificazione': value.dataCertificazione === undefined ? undefined : (value.dataCertificazione === null ? null : value.dataCertificazione.toISOString()),
        'isInviata': value.isInviata,
        'erroreInvioCellulare': value.erroreInvioCellulare,
        'statoCertificazioneDesc': value.statoCertificazioneDesc,
    };
}
exports.CertificazioneCellulareDtoToJSON = CertificazioneCellulareDtoToJSON;
